// Normalisation défensive des liens externes saisis en back-office.
export const websiteUrl = (u) => {
  if (!u) return null;
  const v = String(u).trim();
  if (!v) return null;
  return /^https?:\/\//i.test(v) ? v : `https://${v.replace(/^\/+/, "")}`;
};

export const instagramUrl = (v) => {
  if (!v) return null;
  const raw = String(v).trim().replace(/^@/, "");
  if (/facebook\.com/i.test(raw)) return websiteUrl(raw);
  const m = raw.match(/instagram\.com\/([^/?#\s]+)/i);
  const handle = (m ? m[1] : raw.split(/[/?#\s]/)[0]).replace(/^@/, "");
  return handle ? `https://instagram.com/${handle}` : null;
};
